export default "__VITE_ASSET__BLEWo_h5__"